import type { ReactNode } from "react";

import type { PreviewControl } from "../../hooks/use-preview-control";

import { type DraftView, PreviewPanel } from "./preview-panel";

export interface PreviewLayoutProps {
  children: ReactNode;
  draftView: DraftView;
  /** Proactive messages 报上来的最后操作过的规则；其他标签不传，按回退规则显示。 */
  operatedRuleId?: string;
  preview: PreviewControl;
}

/**
 * 左栏表单、右栏预览的两栏布局：宽屏给预览约一半空间、限在 480–560px，
 * 不足时上下排。左栏是查询容器，栏内字段的 @min-[...] 量的是本栏宽度
 * 而不是整行。Appearance、Chat window、Launcher 与 Proactive messages 四个标签共用。
 */
export function PreviewLayout({
  children,
  draftView,
  operatedRuleId,
  preview,
}: PreviewLayoutProps) {
  return (
    <div className="grid grid-cols-1 items-start gap-4.5 @min-[60rem]:grid-cols-[minmax(0,1fr)_clamp(30rem,50%,35rem)]">
      <div className="@container flex min-w-0 flex-col gap-3.5">{children}</div>
      <PreviewPanel
        draftView={draftView}
        operatedRuleId={operatedRuleId}
        preview={preview}
      />
    </div>
  );
}
